import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent, } from '@cargomatic/ui';
import { getClassName } from '../../utils/ui/classes';
import Badge from 'components/v2/Badge';
import { Info } from 'lucide-react';
const DescriptionListItem = ({ label, labelClassName, children, className, darkMode, info, position, dataTestId, badgeInfo, badgeColor, }) => (React.createElement("div", { className: getClassName(className), "data-testid": dataTestId || 'description-list-item' },
    React.createElement("dt", { "data-testid": "dt-138eb68d", className: getClassName('my-0 text-sm font-medium', labelClassName, {
            'text-gray-500': !darkMode,
            'text-gray-200': darkMode,
        }) },
        React.createElement("div", { className: "flex items-center", "data-testid": "description-list-item-header" },
            label,
            badgeInfo && (React.createElement(Badge, { dataTestId: "Badge-f03af3d9", color: badgeColor || 'gray' }, badgeInfo)),
            info && (React.createElement(TooltipProvider, null,
                React.createElement(Tooltip, null,
                    React.createElement(TooltipTrigger, { asChild: true },
                        React.createElement("div", { className: "ml-1", "data-testid": "description-list-item-info" },
                            React.createElement(Info, { size: 14 }))),
                    React.createElement(TooltipContent, { side: position || 'top', className: "max-w-xs" },
                        React.createElement("p", null, info))))))),
    React.createElement("dd", { "data-testid": "dd-33c9987e", className: getClassName('break-words mt-1 text-sm', {
            'text-gray-900': !darkMode,
            'text-white': darkMode,
        }) }, children)));
DescriptionListItem.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    darkMode: PropTypes.bool,
};
DescriptionListItem.defaultProps = {
    darkMode: false,
};
export default DescriptionListItem;
